import { NgModule } from "@angular/core";
import { LeadModule } from "src/app/common/components/dialogs/lead/lead.module";
import { NotificationSettingsModule } from "src/app/common/components/dialogs/notification-settings/notification-settings.module";
import { LoginErrorDialogModule } from "src/app/common/components/login-error-dialog/login-error-dialog.module";

@NgModule({ imports: [NotificationSettingsModule, LoginErrorDialogModule, LeadModule] })
export class AppDialogsModule {}
